import axios from 'axios';
import { loader } from 'graphql.macro';
import { v4 as uuidv4 } from 'uuid';

import { CF_DOMAIN } from '../../../constants/aws';
import { MAX_FILE_UPLOAD_SIZE } from '../../../constants/misc';
import { getExtension, isBlockedFile } from '../../files/utils';

const uploadUrlQuery = loader('../../../graphql/queries/s3.graphql');

export async function uploadImageFile(file, { apolloClient, currentUser }) {
  if (!file.type.startsWith('image/')) {
    throw new Error('File is not an image');
  }
  if (isBlockedFile(file)) {
    throw new Error(`File type not allowed: ${file.name}`);
  }
  if (file.size > MAX_FILE_UPLOAD_SIZE) {
    throw new Error(`File too large: ${file.name}`);
  }

  const fileUUID = uuidv4();
  const fileType = getExtension(file.name) || file.type.split('/')[1];

  const { data } = await apolloClient.query({
    query: uploadUrlQuery,
    variables: {
      fileName: `assets/${currentUser.company.id}/${fileUUID}.${fileType}`,
      fileType,
    },
  });

  await axios.put(data.simpleStorageUploadUrl, file, {
    headers: { 'Content-Type': fileType },
  });

  return `${CF_DOMAIN(currentUser)}${fileUUID}.${fileType}`;
}
